import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { selectUser } from '@/store/selectors/userSelectors';
import { envIsNormal } from '@/constants/constants';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

export function useOntarioLoginMigration(): void {
  const { openModal } = useModal();
  const user = useSelector(selectUser);
  const seen = useRef(false);

  useEffect(() => {
    // Only do this for normal build mode
    if (!envIsNormal()) {
      return;
    }

    // If the user is from Canada with a province of Ontario, show the Ontario migration modal
    if (user && user.countryCode === 'CA' && user.subdivision.code === 'CA-ON' && !seen.current) {
      seen.current = true;
      openModal(MODALS.ONTARIO_MIGRATION);
    }
  }, [user]);
}
